import initialState from '../store/initialState'
import prospectsTypes from '../constants/prospectsTypes'

export default function prospectsReducer(state = initialState.prospects, action) {
  switch (action.type) {

    case prospectsTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    // GET
    case prospectsTypes.resend.request:{
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case prospectsTypes.resend.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true
      }
    }

    case prospectsTypes.resend.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // INDEX
    case prospectsTypes.destroy.request:
    case prospectsTypes.export.request:
    case prospectsTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case prospectsTypes.destroy.success:
    case prospectsTypes.index.success: {
      if (action.payload.serial && state.serial && action.payload.serial < state.serial) {
        // ignore
        // console.log('index request ignored; consequent request already served')
        return {
          ...state
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.prospects,
        pagination: action.payload.pagination,
        totals: action.payload.totals
      }
    }

    case prospectsTypes.export.success: {
      return {
        ...state,
        fetching: false,
        fetched: true,
      }
    }

    case prospectsTypes.destroy.failure:
    case prospectsTypes.export.failure:
    case prospectsTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/prospectsReducer.js